import React from 'react'

import { EmptyRow, Pagination, Spinner, Table, Td, Tr } from '@components'
import type { ShowClientResponse } from '@models/client.model'
import { clientApi } from '@services/ClientApi'
import { useQuery } from '@utils/hooks'

interface DownloadsProps {
	clientInfo?: ShowClientResponse
}

export function Downloads({ clientInfo }: DownloadsProps) {
	const query = useQuery()
	const page = Number(query.get('page')) || 1

	const { data, isLoading } = clientApi.useGetClientDownloadHistoryQuery(
		{ clientId: clientInfo?.id || '', page },
		{ skip: !clientInfo?.id }
	)

	if (isLoading) {
		return (
			<div className='flex justify-center mt-10'>
				<Spinner size='md' />
			</div>
		)
	}

	const history = data?.data || []
	const meta = data?.meta

	return (
		<>
			<Table
				th={[
					{ label: 'Nome do Arquivo' },
					{ label: 'Data' },
					{ label: 'Módulo' },
					{ label: 'IP' },
				]}
			>
				{history.map((file) => (
					<Tr key={file.id}>
						<Td>{file.file?.name || '-'}</Td>
						<Td>{file.downloadedAt || '-'}</Td>
						<Td>{file.moduleName || '-'}</Td>
						<Td>{file.ip || '-'}</Td>
					</Tr>
				))}
				{history.length === 0 && (
					<EmptyRow message='Nenhum download registrado' tdAmount={4} />
				)}
			</Table>

			<div className='mt-4'>
				<Pagination
					pageCount={meta?.lastPage || 0}
					maxAmount={meta?.total || 0}
					perPage={meta?.perPage || 0}
				/>
			</div>
		</>
	)
}
